<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import tableMixin from '@/helpers/mixins/table' 

export default {
  page: {
    title: "Müşteri Listesi",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  mixins: [ tableMixin ],
  components: {
    Layout,
    PageHeader
  },
  data() {
    return {
        details:[],
        search: true,
        title: "MÜŞTERİ LİSTESİ",
        items: [
        {
          text: "ANASAYFA",
          href: "/",
        },
        {
          text: "MÜŞTERİ LİSTESİ",
          active: true,
        },
      ],
      detailSearch:true,
      form:{
        tur:'',
        status:'',
        enddateend : '',
        enddate:'',
        startdate:'',
        startdateend:'',
        province:'',
        bolge:'',
        tariff:''
      },
      ilList: [],   
      bucakList:[],
      rows: [],
      tariffList: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {
        },
        sort: [
          {
            field: '',
            type: '',
          },
        ],
        page: 1,
        perPage: 50,
      },
      currentPage: 0,
      selected: 0,
      pageLength: 0,
      url: "reports/bitis-tarihi",
      paginationOptions: {
        enabled: true,
        dropdownAllowAll: false,
        perPage: 50,
        setCurrentPage: 1,
        perPageDropdown: [50, 100, 200],
      },
      openRightDrawer: false,
      selectOptions: {
        enabled: false,
        selectOnCheckboxOnly: true,
        selectionInfoClass: 'custom-class',
        selectionText: 'adet kayıt seçildi',
        clearSelectionText: 'seçimi iptal et',
        disableSelectInfo: false,
        selectAllByGroup: false,
      },
     columns: [
        {
          label: '#',
          field: '#',
          sortable: false,
        },
        {
          label: 'Kullanıcı Adı',
          field: 'username',
        },
         {
          label: 'İsim Soyisim',
          field: 'fullname',
        },
        {
          label: 'Bitiş Tarihi',
          field: 'expiredate',
        },
        {
          label: 'Servisi',
          field: 'tariff_name',
        },
         {
          label: 'İlçe',
          field: 'district_name',
        },
        {
          label: 'Telefon',
          field: 'phonenumber',
          sortable: false,
        },
        {
          label: 'Whatsapp',
          field: 'phonenumber2',
          sortable: false,
        }
      ],
    };
  },
  mounted() {
    this.setSelected({ id : 0},'il')

    this.getTariff()
    var currentURL = window.location.href;
    var params = new URLSearchParams(new URL(currentURL).search);
    var statusValue = params.get("status");

    this.form.status = statusValue
    this.updateParams({columnFilters : {status : statusValue}});
    this.loadItems()
  },
  methods: {
    getTariff(){
      this.$http.post('/tariff/getByGroup', { groupName : 'wifi' ,output:'only'})
        .then(response => this.tariffList = response.data.content )
    },
    async setSelected(val,event){
        const object = event + 'List' 
        const { id } = val
        const response = await this.$http.post(`/address/${event}/${id}`)

        if(response.data.error) return;
        this[object] = response.data;
    },
    formSubmit(){
      this.updateParams({columnFilters : {...this.form}});
      this.loadItems()
    },
 
    excelExport() {
      this.$http.post('/reports/export/sales',  {...this.form})
      .then((response) => {
          var temp = 'data:application/vnd.ms-excel;base64,'
              +encodeURIComponent(response.data.content);  
          var download = document.createElement('a');  
          download.href = temp;  
          download.download = response.data.filename;  
          document.body.appendChild(download);  
          download.click();
          document.body.removeChild(download);
      });
    },
    yenile(props){
      location.href="/musteri-ara?username=" + props.username
     // this.$parent.$bvModal.show('renewal_modal')
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
     <div class="row mb-3">
        <div class="col-md-6 offset-lg-6 text-end">
           <div class="button-items mx-2">
             
             <button 
                class="btn btn-outline-light bg-light" 
                :class="{ activeClass: detailSearch }"
                type="button"  
                @click="detailSearch = !detailSearch">
                <i class="bx bx-filter-alt"></i> Detaylı Arama
            </button>
          </div>
      </div>
     <Transition name="fade" v-if="detailSearch">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <form class="needs-validation" @submit.prevent="formSubmit">
                <div class="row">
                  <div class="col-md-6">
                    <div class="row">
                      <div class="col-xl-6">
                        <div class="mb-3">
                          <label>Müşteri Durumu</label>
                          <select v-model="form.status" class="form-select">
                            <option value="">Seçiniz</option>
                            <option value="1">Aktif</option>
                            <option value="2">Günü Biten</option>
                            <option value="3">İptal</option>
                            <option value="4">Dondurulmuş</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-xl-6">
                        <div class="mb-3">
                          <label>Tarife</label>
                          <select v-model="form.tariff" class="form-select">
                            <option value="">Seçiniz</option>
                            <option :value="trf.id" v-for="(trf, i) in tariffList" :key="i">{{ trf.name }}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                       <div class="col-xl-6">
                          <div class="mb-3">
                            <label>İlçe</label>
                              <v-select
                                label="name" 
                                v-model="form.province"
                                :options="ilList" 
                                :reduce="country => country.id"
                                @option:selecting="setSelected($event,'bucak')"><span slot="no-options">Sonuç Bulunamadı</span>
                            </v-select>
                          </div>
                        </div>
                         <div class="col-xl-6">
                          <div class="mb-3">
                            <label for="bolge">Bölge</label>
                              <v-select 
                                label="name"  
                                v-model="form.bolge"                    
                                :options="bucakList" 
                                :reduce="country => country.id"
                                @option:selecting="setSelected($event,'koy')"><span slot="no-options">Sonuç Bulunamadı</span>
                              </v-select>
                          </div>
                        </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="row">
                       <div class="col-xl-12">
                          <div class="row">
                            <div class="col-md-12 mb-3">
                              <label class="d-flex justify-content-between">Üyelik Tarih Aralığı
                                <span 
                                  v-if="form.startdate || form.startdateend" 
                                  class="text-danger" 
                                  @click="form.startdate= '' ;form.startdateend= ''">
                                  temizle</span>
                                </label>
                              <div class="input-group">
                                <input type="date" class="form-control"  v-model="form['startdate']">
                                <button style="border:0;background: transparent;">  - </button>
                                <input type="date" class="form-control"  v-model="form['startdateend']">
                              </div>
                            </div>
                          </div>
                        </div>

                    </div>
                    <div class="row">
                       <div class="col-xl-12">
                          <div class="row">
                            <div class="col-md-12 mb-3">
                              <label class="d-flex justify-content-between">Bitiş Tarih Aralığı
                                <span 
                                  v-if="form.enddate || form.enddateend" 
                                  class="text-danger" 
                                  @click="form.enddate= '' ;form.enddateend= ''">
                                  temizle</span>
                                </label>
                              <div class="input-group">
                                <input type="date" class="form-control"  v-model="form['enddate']">
                                <button style="border:0;background: transparent;">  - </button>
                                <input type="date" class="form-control"  v-model="form['enddateend']">
                              </div>
                            </div>
                          </div>
                        </div>

                    </div>
                  </div>
                  <div class="col-xl-2">
                    <div class="row">
                      <div class="col-xl-12">
                          <div class="mb-3">
                            <label for="bolge">Filtre</label>
                              <select v-model="form.tur" class="form-select">
                                <option value="">Seçiniz</option>
                                <option value="k">Kurumsal Müşteriler</option>
                                <option value="u">Ücretsi Müşteriler</option>
                              </select>
                          </div>
                        </div>
                      <div class="col-md-12 mb-3" >
                        <label>-</label>
                        <div class="button-items">
                            <button 
                              type="submit"
                              class="btn btn-primary w-100 "   
                              >
                              Sorgula
                            </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <!-- end card -->
          </div>
        </div>
      </div>
    </Transition>
      <!-- end col -->
    </div>
    <div class="row">
      <div class="col-12">
          <vue-good-table 
            mode="remote"
            styleClass="vgt-table bordered condensed"
            :line-numbers="true" 
            :total-rows="totalRecords"
            :columns="columns"
            :rows="rows"
            :pagination-options="paginationOptions"
            :is-loading.sync="isLoading"
            @on-page-change="onPageChange"
            @on-sort-change="onSortChange"
            @on-column-filter="onColumnFilter"
            @on-per-page-change="onPerPageChange">
            <template slot="loadingContent">
              <div>Yükleniyor</div>
            </template>
             <template
                  slot="table-row"
                  slot-scope="props"
                >
                  <b-dropdown
                    v-if="props.column.field === '#'"
                    class="ms-2 "
                    toggle-class="font-size-16 p-0"
                    toggle-tag="a"
                    variant="white"
                    right
                >
                    <template #button-content>
                      <i class="mdi mdi-dots-horizontal"></i>
                    </template>
                    <template>
                        <b-dropdown-item @click="yenile(props.row)"><i class="bx bx-revision"></i> Detaya Git</b-dropdown-item>
                    </template>
                  </b-dropdown>
                </template>
          </vue-good-table>
      </div>
    </div>
  </Layout>
</template>